import React, { useState } from 'react'
import ServiceList from './components/ServiceList'
import { useSelector } from 'react-redux'
import StoreServiceCategories from './components/StoreServiceCategories'

export default function StoreService({
    isMobile,
    business,
    location
}) {
    const selectedCategory = useSelector(state => state.content.storeProfileServiceCategory)
    // const [selectedCategory, setSelectedCategory] = useState(null)

    return (
        <div className='w-full py-5' id='store-service'>
            <div className='m-auto w-full max-w-[1280px] flex justify-start gap-10 smsize:max-w-full smsize:flex-col smsize:p-5 smsize:gap-5 flex-col'>
                {/* <StoreServiceCategories
                    business={business}
                    isMobile={isMobile}
                    selectedCategory={selectedCategory}
                    setSelectedCategory={setSelectedCategory}
                /> */}
                <ServiceList
                    business={business}
                    isMobile={isMobile}
                    selectedCategory={selectedCategory}
                />
            </div>
        </div>
    )
}
